(function () {
  angular.module('MktzapApp.Factories')
    .factory('ChatBotConfigsService', ChatBotConfigsService);

  ChatBotConfigsService.$inject = ['$resource'];

  function ChatBotConfigsService ($resource) {
    return $resource(apiUrl + '/chatbot-configs/:id', { id: '@id' }, {
      create: { method: 'POST', params: {}, isArray: false },
      update: { method: 'PATCH', params: {}, isArray: false },
      delete: { method: 'DELETE', params: {}, isArray: false },
      getById: { url: apiUrl + '/chatbot-configs/get-by-id', method: 'GET', isArray: false },
      getAllFiltered: { url: apiUrl + '/chatbot-configs/get-all-filtered', method: 'GET', isArray: true },
      getChatBotParams: { url: apiUrl + '/chatbot-configs/get-chatbot-params', method: 'GET', isArray: false }
    });
  }
})();
